const AWS = require('aws-sdk');
const secretsManager = new AWS.SecretsManager({
    region: process.env.AWS_DEFAULT_REGION
});
let loaded = false;

const getSecretsFromManager = async () => {
    console.log('Loading secrets from AWS');
    try {
        const data = await secretsManager.getSecretValue({ SecretId: process.env.AWS_SECRET }).promise();
        let parsedSecret;
        if ('SecretString' in data) {
            const secret = data.SecretString;
            parsedSecret = JSON.parse(secret);
        } else {
            let buff = Buffer.from(data.SecretBinary, 'base64');
            const decodedBinarySecret = buff.toString('ascii');
            parsedSecret = JSON.parse(decodedBinarySecret);
        }
        console.log('Finished loading secrets from AWS');
        return parsedSecret;
    } catch (err) {
        console.error('Could not obtain secrets from AWS', err);
        throw err;
    }
};

const loadEnv = async () => {
    if (loaded) {
        console.warn(`AWS Secrets are already loaded. Skipping loading them again`);
        return;
    }
    const secrets = await getSecretsFromManager();
    for (const [key, value] of Object.entries(secrets)) {
        if (process.env[key]) {
            console.warn(`Env variable ${key} is defined. Will ignore value from AWS`);
        } else {
            process.env[key] = value;
        }
    }
    loaded = true;
};

module.exports = {
  getSecretsFromManager,
  loadEnv
};
